import React from 'react';
import { Box, Botao, TipoBotao, Alerta, TipoAlerta } from "@intechprev/componentes-web";

interface Props {
  Avancar: () => void;
  Voltar: () => void;
  NumeroPassoAtual: number;
}

interface State {
  CorCheckbox: string;
  checked: boolean;
}

export class Passo9 extends React.Component<Props, State> {

  private alerta = React.createRef<Alerta>();

  constructor(props: Props) {
    super(props);

    this.state = {
      CorCheckbox: "success",
      checked: true
    }
  }

  render() {
    return (
      <Box titulo={`Passo ${this.props.NumeroPassoAtual} - Código de Ética e Conduta PREVIRB`}>

        <span>
          {"Clique "}
          <a target={"_blank"} rel={"noopener noreferrer"} href={"./codigo_etica_conduta.pdf"}>{"aqui"}</a>
          {" para baixar o Código de Ética e Conduta da PREVIRB."}
        </span>

        <div className={`d-flex align-items-baseline alert alert-${this.state.CorCheckbox}`}>
          <input
            type={"checkbox"}
            id={"manifestacao"}
            name={"manifestacao"}
            checked={this.state.checked}
            onChange={() => {
              this.setState({
                checked: !this.state.checked,
                CorCheckbox: !this.state.checked ? "success" : "danger"
              });
            }}
          />
          <label className={"m-2"} htmlFor={"manifestacao"}>
            {"Formalizo minha adesão aos termos do Código de Ética e Conduta da PREVIRB, aprovado por seu Conselho Deliberativo, através da Resolução CONDEL 024/2021, de 21/07/2021, comprometendo-me a respeitar, no que couber, os princípios e regras nele estabelecidos."}
          </label>
        </div>

        <Alerta
          tipo={TipoAlerta.danger}
          ref={this.alerta}
        />

        <Botao
          onClick={this.props.Voltar}
          titulo={"Voltar"}
          className={"m-2"}
          tipo={TipoBotao.light}
          icone={"angle-double-left"}
          iconeDireita
        />

        <Botao
          onClick={this.props.Avancar}
          titulo={"Continuar"}
          icone={"angle-double-right"}
          iconeDireita
        />
      </Box>
    );
  }
}